import http from '@/plugins/axios/axios';
import { CHVAE_TOKEN } from '@/global';

export default class LockProcessoService {

    constructor() {
        this.baseUrl = 'https://auth.ikponto.com.br';
        this.token = JSON.parse(sessionStorage.getItem(CHVAE_TOKEN)); 
    }

    listar() {       
        return http.request({
            method: 'get', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl+'/lock/processo/calculo/listar-locks'
        });
    }

    liberar(requisicao) {       
        return http.request({
            method: 'post', 
            headers: {Authorization: 'Bearer '+this.token.valor}, 
            url: this.baseUrl+'/lock/processo/calculo/liberar', 
            data: requisicao
        });
    }

    liberarTotal(requisicao) {       
        return http.request({
            method: 'post', 
            headers: {Authorization: 'Bearer '+this.token.valor}, 
            url: this.baseUrl+'/lock/processo/calculo/liberar/total', 
            data: requisicao
        });
    }

    listarSesoes() {       
        return http.request({
            method: 'get', 
            headers: {Authorization: 'Bearer '+this.token.valor}, 
            url: this.baseUrl+'/usuario/listar/sessoes'
        });
    }

}